import { Stack, Typography } from "@mui/material";
import { UploadHgModal } from "../modal";
import { useState } from "react";
import { CIDAddedType } from "../../../types/apiTypes";
import { CheckInCircleIcon } from "../../images";

type Props = {
  cid: CIDAddedType;
  setHGData: (cid: CIDAddedType) => void;
};

export const UploadHgBlock = ({ cid, setHGData }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [updatedCid, setUpdatedCid] = useState<CIDAddedType | null>(null);

  const submitHandler = (updatedCid: CIDAddedType) => {
    setUpdatedCid(updatedCid);
    setHGData({ ...cid, ...updatedCid });
    setIsOpen(false);
  };

  const isUploaded =
    updatedCid && (updatedCid.files.length > 0 || updatedCid.urls.length > 0);

  return (
    <Stack alignItems={"flex-start"} gap={"12px"}>
      <Typography
        variant="subtitle1"
        sx={{
          color: "#464646",
        }}
      >
        Upload an HG Insights Spend file to auto-enrich accounts with Cloud
        Maturity Scores and IT budgets — saved at the account level and applied
        to all leads and playbooks for those accounts.
      </Typography>
      <Stack gap={"4px"}>
        <Stack flexDirection={"row"} gap={"8px"} alignItems={"center"}>
          <Typography
            variant="subtitle1"
            sx={{
              color: "#496389",
              textDecoration: "underline",
              textUnderlineOffset: "3px",
              cursor: "pointer",
              "&:hover": {
                opacity: "0.8",
              },
            }}
            onClick={() => setIsOpen(true)}
          >
            Upload HG Insights
          </Typography>
          {isUploaded && <CheckInCircleIcon width={"16px"} height={"16px"} />}
        </Stack>

        {isUploaded && (
          <Typography
            sx={{
              color: "#797979",
              fontSize: "13px",
              lineHeight: "13px",
              fontWeight: 500,
            }}
          >
            {`${updatedCid.files.length > 0 ? `${updatedCid.files.length} file${updatedCid.files.length > 1 ? "s" : ""}` : ""}`}
            {`${updatedCid.files.length > 0 && updatedCid.urls.length > 0 ? " & " : ""}`}
            {`${updatedCid.urls.length > 0 ? `${updatedCid.urls.length} link${updatedCid.urls.length > 1 ? "s" : ""}` : ""}`}{" "}
            uploaded
          </Typography>
        )}
      </Stack>

      {isOpen && (
        <UploadHgModal
          cid={cid}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onSubmit={submitHandler}
        />
      )}
    </Stack>
  );
};
